import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of, EMPTY } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { SharedService } from '@app/core';
import { Game } from '@courses/entities';
import { GameService } from '@games/services/game.service';

@Injectable({
  providedIn: 'root',
})
export class GameDetailResolverService {
  constructor(
    private gameService: GameService,
    private sharedService: SharedService,
    private router: Router
  ) {}

  private handleError = (courseId: number) => {
    this.sharedService.errorAlert('Something wrong!');
    this.router.navigate(['/course', courseId, 'game']);

    return EMPTY;
  };

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Game> | Observable<never> {
    const courseId = +route.paramMap.get('id')!,
      gameId = +route.paramMap.get('gameId')!;

    return this.gameService.getGame(courseId, gameId).pipe(
      catchError(() => this.handleError(courseId)),
      mergeMap(game => {
        if (game) {
          return of(game);
        }

        this.handleError(courseId);
      })
    );
  }
}
